import React from 'react';
import styles from './Footer.module.css'

export const Footer = () => {
    return (
        <div className={styles.container}>
            © 2022 All Rights Reserved
        </div>
    );
};